export enum FileUploadState {
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  WARNING = 'WARNING',
  NULL = 'NULL',
  ERROR = 'ERROR'
}
